import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const NotFound = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://lottie.host/d987597c-7676-4424-8817-7fca6dc1a33e/BVrFXsaeui.json',
    });
  
    return () => {
      animation.destroy(); // 🔥 Clean up on unmount
    };
  }, []);
  

  return (
    <div className="container vh-100 d-flex flex-column justify-content-center align-items-center text-center">
      <div
        ref={containerRef}
        style={{ width: '300px', height: '300px' }}
        className="mb-4"
      />
      <h3 className="display-6 text-danger fw-bold mb-3">صفحه پیدا نشد!</h3>
      {/* <p className="lead text-muted mb-4">
        Oops! The page you're looking for doesn’t exist or has been moved.
      </p> */}
      {/* <a href="/home" className="btn btn-primary btn-lg">
        بازگشت به خانه
      </a> */}
    </div>
  );
};

export default NotFound;
